import { ArrowRightLeft, Check, Download } from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";

const aiPoweredDataMigration = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Upload any Excel file — no special format needed." },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Collects, corrects and sets up data in Soomuch.ai in 3 minutes." },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Final import completes with full accuracy." },
];

const appDownloadAutomator = [
    { icon: "", text: "1. System sends the app link three times via SMS and WhatsApp." },
    { icon: "", text: "2. After the 3rd attempt, a list of non-downloaders is shared to your school." },
    { icon: "", text: "3. Teachers help these parents install the app at PTM meetings." },
];

const schoolBenefits = [{
    title: "Q. Show Student A's attendance for last month.",
    description: "Instant report and downloadable summary.",
}, {
    title: "Q. How to add a new student to my class?",
    description: "Step-by-step click guide.",
}, {
    title: "Q. Show me the Pending Fee list for this month",
    description: "Instant list with download",
}, {
    icon: <ArrowRightLeft className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI-Powered Data Migration",
    description: "Quickly and safely transfer all your school’s data — from student records to fee systems — into one smart platform. Upload once, AI cleans & imports, dashboards ready in minutes.",
    footer: <div className="space-y-3">
        {aiPoweredDataMigration.map((section, index) => (
            <div key={"f" + index} className="flex items-center gap-3">
                {!!section.icon && section.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
        ))}
    </div>
}, {
    icon: <Download className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "App Download Automator",
    description: "We ensure every parent installs your school app within one month.This saves money on repeated SMS/WhatsApp campaigns and makes communication faster and cheaper.",
    footer: <div className="space-y-3">
        {appDownloadAutomator.map((section, index) => (
            <div key={"f" + index} className="flex items-center gap-3">
                {!!section.icon && section.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
        ))}
    </div>
}];


export default function AiPoweredChat() {

    return (
        <Box
            badge={"WHAT WE DELIVER"}
            title={"AI-Powered Chat — Your School’s Smart Assistant"}
            description={"Ask anything — attendance, fees, marks, homework, admissions. The chatbot shows click-based steps and instant answers, 24×7."}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {schoolBenefits.slice(0, 3).map((member, index) => <MarktingCard key={"memberasdsadInnerCard" + index} member={member} />)}
                    </div>
                </div>
            }
            rightBlock={schoolBenefits.slice(3).map((member, index) => <MarktingCard key={"memberUpperCardIN" + index} member={member} />)}
        />
    );
}